/* Verified Shopify Files neutral placeholder; compatible with the existing savedProducts.v1 image validator. */
window.MGProductPlaceholder = { image: "https://cdn.shopify.com/s/files/1/1000/4879/7985/files/mg-product-image-unavailable.png?v=1792394150" };
